import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Auth } from 'aws-amplify';

import { UntilDestroy } from '@ngneat/until-destroy';
import { ForgotService } from './service/forgot.service';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-forgot',
  templateUrl: './forgot.component.html',
  styleUrls: ['./forgot.component.css']
})
export class ForgotComponent implements OnInit {
  username:string;
  year:string;
  password:string;
  verificationcode:string;
  //userPool:CognitoUserPool;
  showStep2:boolean;
  errorMessage:string;
  sendMessage:string;
  showSuccess:boolean;
  showSpinner:boolean = false;
  constructor(
    private router:Router,
    private fsrv:ForgotService
  ) { }

  ngOnInit() {
    this.showSpinner = true;
    this.year = new Date().getFullYear().toString();
    this.showStep2 = false;
    this.showSuccess = false;
    if(this.router.url.split('/')[2]){
      this.username = this.router.url.split('/')[2];
      this.forgot();
    }else{
      this.showSpinner = false;
    }
  }

  // find inspiration here https://github.com/awslabs/aws-cognito-angular-quickstart/blob/master/src/app/public/auth/forgot/forgotPassword.component.ts
  
  forgot(){
  //   var poolData = {
  //     UserPoolId : environment.cognito_user_pool_id,
  //     ClientId : environment.cognito_client_id
  //   };

  //   this.userPool = new CognitoUserPool(poolData);

  //   let userData = {
  //     Username: this.username,
  //     Pool: this.userPool
  //   };
  
  //   let cognitoUser = new CognitoUser(userData);

  this.fsrv.forgotPassword(this.username)
        .subscribe((data) => {
          this.errorMessage = null;
          //console.log(data);
           this.showSpinner = false;
          this.showStep2 = true;
          this.sendMessage = 'An email with the verification code was sent to your email'
        }, (err) => {
          this.errorMessage = err.message;
          console.error(err.message);
        });
        // Auth.forgotPassword(this.username)
        // .then((data) => {
        //   this.errorMessage = null;
        //   //console.log(data);
        //   this.showStep2 = true;
        //   this.sendMessage = 'An email with the verification code was sent to '+data.CodeDeliveryDetails.Destination      
        // })
        // .catch((err) => {
        //   this.errorMessage = err.message;
        //   console.error(err.message);
        // })
  //   cognitoUser.forgotPassword({
  //     onSuccess: (data) => {
  //       //console.log(data);
  //       this.showStep2 = true;
  //     },
  //     onFailure: (err) => {
  //         this.errorMessage = err.message;
          
  //     },
  //     inputVerificationCode: (data) => {
  //       this.errorMessage = null;
  //       //console.log(data);
  //       this.sendMessage = 'An email with the verification code was sent to '+data.CodeDeliveryDetails.Destination
  //         this.showStep2 = true;
  //     }
  // });
  
  }
  

confirmNewPassword() {
    // let userData = {
    //     Username: this.username,
    //     Pool: this.userPool
    // };

    // let cognitoUser = new CognitoUser(userData);

    this.fsrv.resetPassword(this.username, this.password, this.verificationcode)
        .subscribe((data) => {
          this.errorMessage = null;
         //console.log(data);
          this.showSuccess = true;
          this.sendMessage = 'Password changed successfully. Redirecting to login page...';
          setTimeout(() => {
            this.router.navigate(['/login/'+this.username]);
          }
          , 3000);
        }, (err) => {
          this.errorMessage = err.message;
          console.error(err.message);
        });

        // Auth.forgotPasswordSubmit(this.username,this.verificationcode,this.password)
        // .then(() => {
        //   this.sendMessage = null;
        //   this.showSuccess = true;
        //   setTimeout(() => {
        //     this.router.navigate(['/login/'+this.username]);
        //   }
        //   , 3000);
        // }).catch((err) => {
        //   this.sendMessage = null;
        //   this.showSuccess = false;
        //   this.errorMessage = err.message;
        // })
    // cognitoUser.confirmPassword(this.verificationcode, this.password, {
    //     onSuccess: () => {
    //       this.sendMessage = null;
    //       this.showSuccess = true;
    //     },
    //     onFailure: (err) => {
    //       this.sendMessage = null;
    //       this.showSuccess = false;
    //       this.errorMessage = err.message;
    //     }
    // });
}
confirm(){
  this.router.navigate(['/login']);
}
}
